import { render, staticRenderFns } from "./UploadDocumentForm.vue?vue&type=template&id=b3c403c4&"
import script from "./UploadDocumentForm.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports